import {configureStore} from '@reduxjs/toolkit';
import authReducer from "./authSlice";
import exchangeActiveReducer from "./exchangeActiveSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    exchangeActive: exchangeActiveReducer,
  },
  devTools: process.env.REACT_APP_NODE_ENV !== 'production',
});